import { z } from "zod";

export const campaignMessageTypeEnum = z.enum(["update", "note_of_support"]);

export type CampaignMessageType = z.infer<typeof campaignMessageTypeEnum>;
